import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFormik, FieldArray, FormikProvider } from "formik";
import CeroButton from "../../../../components/CeroButton";
import useStyles from "./styles";
import CeroInput from "../../../../components/CeroInput";
import AddIcon from "@mui/icons-material/Add";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { sendSustainabilityRiskQuestions } from "../../../../redux/actions";
import { STATUS } from "../../../../redux/constants";
import CeroPopUp from "../../../../components/CeroPopUp";
import ViewQuestions from "../ViewQuestions";
import { getMaterialityIndustries } from "../../../../redux/actions/materiality";
import CloseIcon from "@mui/icons-material/Close";

const validationSchema = Yup.object().shape({
  users: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required("Name is required"),
      email: Yup.string()
        .email("Invalid email format")
        .required("Email is required"),
      industry: Yup.string().nullable(),
    })
  ),
});

const SendQuestions = ({ setOpen, sendQuestionnairesStatus }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [fields, setFields] = useState([{ name: "", email: "" }]);
  const [viewQuestionPopup, setViewQuestionPopup] = useState(false);
  const [currentIndustry, setCurrentIndustry] = useState("");

  const formik = useFormik({
    initialValues: {
      users: fields,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const payload = {
        sender_list: values.users.map((user) => ({
          name: user.name,
          email: user.email,
        })),
      };
      dispatch(sendSustainabilityRiskQuestions(payload));
      formik.resetForm();
    },
  });
  const handleAddMore = () => {
    setFields([...fields, { name: "", email: "" }]);
    formik.setFieldValue("users", [
      ...formik.values.users,
      { name: "", email: "" },
    ]);
  };

  const canAddMore = formik.values.users.every(
    (item) => item.name !== "" && item.email !== ""
  );

  const handleSubmit = () => {
    formik.handleSubmit();
    setOpen(false);
  };

  useEffect(() => {
    dispatch(getMaterialityIndustries());
  }, [dispatch]);

  useEffect(() => {
    if (sendQuestionnairesStatus === STATUS.SUCCESS) {
      formik.resetForm();
    }
  }, [sendQuestionnairesStatus]);

  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };

  const [openQuestionsForm, setOpenQuestionsForm] = useState(false);
  const createQuestionStatus = useSelector(
    (state) =>
      state.sustainabilityRiskAssessment
        .createSustainabilityRiskAssessementQuestions.status
  );
  const companyName = "company";

  return (
    <Box className={classes.popUp}>
      <CloseIcon onClick={handleCancel} className={classes.closeIcon} />
      <Typography variant="body1" className={classes.popupTitle}>
        Send Questionnaire to Suppliers
      </Typography>
      <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
          <FieldArray name="users">
            {() => (
              <Grid
                display={"flex"}
                flexDirection="column"
                mt={4}
                gap={2}
                justifyContent="flex-start"
                className={classes.eachIndustryBox}
              >
                <Typography
                  display={"flex"}
                  fontSize={14}
                  fontWeight={500}
                  variant="h3"
                >
                  Enter Name, Email ID:
                </Typography>
                {formik.values.users.map((stakeholder, index) => (
                  <Box
                    key={index}
                    display={"flex"}
                    flexDirection="column"
                    gap={1}
                  >
                    <Grid container spacing={2} display={"flex"}>
                      <Grid
                        item
                        xs={6}
                        style={{ paddingTop: index !== 0 ? "0px" : "8px" }}
                      >
                        <CeroInput
                          required
                          id={`name-${index}`}
                          name={`users[${index}].name`}
                          label="Name"
                          value={formik.values.users[index].name}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.users &&
                            formik.touched.users[index]?.name &&
                            Boolean(
                              formik.errors.users &&
                                formik.errors.users[index]?.name
                            )
                          }
                          helperText={
                            formik.touched.users &&
                            formik.touched.users[index]?.name &&
                            formik.errors.users &&
                            formik.errors.users[index]?.name
                          }
                          classes={{
                            container:
                              index === 0
                                ? classes.input
                                : classes.inputWithoutMargin,
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        style={{ paddingTop: index !== 0 ? "0px" : "8px" }}
                      >
                        <CeroInput
                          required
                          id={`email-${index}`}
                          name={`users[${index}].email`}
                          label="Email"
                          value={formik.values.users[index].email}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.users &&
                            formik.touched.users[index]?.email &&
                            Boolean(
                              formik.errors.users &&
                                formik.errors.users[index]?.email
                            )
                          }
                          helperText={
                            formik.touched.users &&
                            formik.touched.users[index]?.email &&
                            formik.errors.users &&
                            formik.errors.users[index]?.email
                          }
                          classes={{
                            container:
                              index === 0
                                ? classes.input
                                : classes.inputWithoutMargin,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                ))}
                <Box
                  display="flex"
                  paddingY={2}
                  paddingLeft={2}
                  gap={1}
                  onClick={canAddMore ? handleAddMore : null}
                  style={{
                    cursor: canAddMore ? "pointer" : "not-allowed",
                    color: canAddMore ? "blue" : "gray",
                  }}
                >
                  <AddIcon />
                  <Typography>Add Name and Email</Typography>
                </Box>
              </Grid>
            )}
          </FieldArray>
          <div className={classes.buttonContainerReview}>
            <CeroButton
              className={classes.buttonPrimary}
              variant="contained"
              type="submit"
              buttonText="Send Email"
              onClick={handleSubmit}
              disabled={
                !(
                  formik.isValid &&
                  formik.dirty &&
                  formik.values.users.every((user) => user.name && user.email)
                )
              }
            />
            <CeroButton
              className={classes.buttonSecondary}
              variant="outlined"
              onClick={handleCancel}
              buttonText="Cancel"
            />
          </div>
        </form>
      </FormikProvider>
      <CeroPopUp
        primaryPopUp={{
          open: viewQuestionPopup,
          onClose: () => setViewQuestionPopup(false),
          content: ViewQuestions({
            openQuestionsForm,
            setOpenQuestionsForm,
            createQuestionStatus,
            companyName,
            currentIndustry,
          }),
          header: { title: "" },
        }}
        classes={{ dialog: classes.popUpdialog }}
        showCloseButton={true}
      />
    </Box>
  );
};

export default SendQuestions;
